export const contactUsReducer = (state = { loading: false }, action) => {
  switch (action.type) {

    case "GET_CONTACT_US_LIST_REQUEST":
      return { ...state, loading: true, contactUsList: null };

    case "GET_CONTACT_US_LIST_SUCCESS":
      return { ...state, loading: false, contactUsList: action.payload };

    case "GET_CONTACT_US_LIST_FAILED":
      return { ...state, loading: false, contactUsList: null, error: action.payload };

    default:
      return state;
  }
};